import BodyText from 'LuxKit/Typography/BodyText'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import { FormattedMessage } from 'react-intl'

function TriplePointTakeoverBannerDescription() {
  const [tier] = useCurrentLoyaltyTier()

  return <BodyText variant="medium" weight="bold" colour={`tier-${tier}-contrast`}>
    <FormattedMessage
      id="6fTTcfOUb4UheHOuMix4"
      defaultMessage="Enjoy triple bonus Société Points on these limited-time special offers."
      description="Site-wide banner text for triple points takeover in the site takeover promotion"
    />
  </BodyText>
}

export default TriplePointTakeoverBannerDescription
